<template>
    <div>
        <div class="upload_docs_header">
            <h1>Company</h1>
            <template v-if="willDisplayGeneralSentEmailButton && generalDocs.data.length > 0">
                <div class="general_docs_header_button_container">
                    <input
                        href="#"
                        class="btn btn-danger general_docs_header_button"
                        @click="sendOfferingInvestorsUpdateDocsEmail"
                        value="Send to Offering Investors"
                        type="button"
                    />
                    <input
                        href="#"
                        class="btn btn-info general_docs_header_button"
                        @click="sendCompanyInvestorsUpdateDocsEmail"
                        value="Send to Company Investors"
                        type="button"
                    />
                </div>
               
                <modal-help>
                    Documents added here are presented to all offerings under this company
                </modal-help>
            </template>
        </div>

        <div>
            <div class="file-type-selector">
                <label for="">File Type</label>
                <select class="form-control" v-model="generalType">
                    <option value="updates">Company Information</option>
                    <option value="offering-doc">Offering Information</option>
                </select>
            </div>

            <div class="uploader margin-bottom-40">
                <label for="">Uploader</label>
                <file-uploader :params="generalUploadParams" :id="1" :fileUploaded="generalFileUploaded"></file-uploader>
            </div>
        </div>

        <div class="text-center" v-if="loading">
            <img src="../../../images/loader.gif" height="100px" width="100px" />
            <p>Please wait ... </p>
        </div>

        <table class="table" v-else>
            <thead>
                <tr>
                    <th>Order</th>
                    <th>Name</th>
                    <!-- <th>Description</th> -->
                    <!-- <th>File Path</th> -->
                    <th>Tag</th>
                    <th>Visibility</th>
                </tr>
            </thead>
            <tr v-for="doc in generalDocs.data">
                <td>{{ doc.order }}</td>
                <td>{{ doc.name }}</td>
                <!-- <td>{{ doc.description }}</td> -->
                <!-- <td>{{ doc.file_path }}</td> -->
                <td>{{ mapDocumentsTag(doc.tag) }}</td>
                <td>{{ doc.is_read_only ? 'Read-Only' : '' }}</td>
                <!-- <td>
                    <a :href="`/admin/${activeEmd.slug}/offerings/${offering.id}/docs/${doc.id}/edit`">
                        edit
                    </a>
                </td> -->
                <td>
                    <a :href="`/admin/${activeEmd.slug}/offerings/${offering.id}/docs/${doc.id}/delete`">
                        delete
                    </a>
                </td>
            </tr>
        </table>
        <pagination :data="generalDocs" @pagination-change-page="loadAndGetGeneralDocument" :limit="1"></pagination>
    </div>
</template>

<script>
    import pagination from "laravel-vue-pagination"
    import ModalHelp from '../ModalHelp';
    import FileUploader from '../FileUploader.vue';

    export default {
        data() {
            return {
                generalType: 'updates',
                loading: false,
            }
        },
        props: [
            'sendOfferingInvestorsUpdateDocsEmail', 'sendCompanyInvestorsUpdateDocsEmail', 'offering', 'generalDocs', 'activeEmd',
            'willDisplayGeneralSentEmailButton', 'toggleGeneralEmailSendButton', 'getGeneralDocument'
        ],
        components: {
            ModalHelp,
            FileUploader,
            pagination,
        },
        computed: {
            generalUploadParams() {
                return {
                    offeringId: this.offering.id, 
                    is_read_only: false, 
                    order: 1,
                    tag: this.generalType,
                    is_personal: false,
                    investments: '',
                }
            },
        },
        methods: {
            generalFileUploaded(doc) {
                this.generalDocs.data.push(doc)
                this.toggleGeneralEmailSendButton(true)
            },
            loadAndGetGeneralDocument(page = 1) {
                this.loading = true
                this.getGeneralDocument(page)
                    .then(() => {
                        this.loading = false
                    })
            },
            mapDocumentsTag(tag) {
                let updatedTag = "";
                switch(tag) {
                    case "updates":
                        updatedTag =  "Company Information";
                        break;
                    case "offering-doc":
                        updatedTag = "Offering Information";
                        break;
                    default:
                        updatedTag = tag;
                }
                return updatedTag;
            }
        }
    }
</script>